'use client';

import React, { createContext, useContext } from 'react';
import { TEntriesResponse } from '../types/types';
import {
    TypeInsightsWithAllLocalesAndWithoutUnresolvableLinksResponse,
    TypeInsightsWithoutUnresolvableLinksResponse,
} from '../_generated';

type TRelatedInsightsContext = {
    items: Record<
        string,
        TEntriesResponse<TypeInsightsWithAllLocalesAndWithoutUnresolvableLinksResponse[]>
    >;
};

const RelatedInsightsContext = createContext<TRelatedInsightsContext>({
    items: {},
});

type TRelatedInsightsProviderProps = {
    children: React.ReactNode;
} & TRelatedInsightsContext;

const RelatedInsightsProvider = ({ children, items }: TRelatedInsightsProviderProps) => (
    <RelatedInsightsContext.Provider value={{ items }}>{children}</RelatedInsightsContext.Provider>
);

export const useRelatedInsightsContext = () => {
    const context = useContext(RelatedInsightsContext);

    if (!context) {
        throw new Error('useRelatedInsightsContext must be used within a RelatedInsightsContext');
    }

    return context;
};

export default RelatedInsightsProvider;
